import React from 'react';
import PropTypes from 'prop-types';

const Timer = ({ fill = '', onClick }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
  >
    <g clipPath="url(#clip0_2513_7837)">
      <path
        d="M8.99985 0.839844C7.38595 0.839844 5.8083 1.31842 4.46639 2.21505C3.12449 3.11168 2.0786 4.3861 1.46099 5.87715C0.843379 7.36819 0.681784 9.0089 0.99664 10.5918C1.31149 12.1747 2.08866 13.6286 3.22986 14.7698C4.37105 15.911 5.82503 16.6882 7.40791 17.0031C8.9908 17.3179 10.6315 17.1563 12.1225 16.5387C13.6136 15.9211 14.888 14.8752 15.7846 13.5333C16.6813 12.1914 17.1598 10.6137 17.1598 8.99984C17.1598 6.83568 16.3001 4.76015 14.7698 3.22985C13.2395 1.69956 11.164 0.839844 8.99985 0.839844V0.839844ZM8.99985 15.5248C7.70932 15.5248 6.44778 15.1422 5.37475 14.4252C4.30172 13.7082 3.4654 12.6891 2.97153 11.4969C2.47767 10.3046 2.34845 8.99261 2.60022 7.72688C2.85199 6.46115 3.47344 5.29851 4.38598 4.38597C5.29851 3.47343 6.46116 2.85199 7.72688 2.60022C8.99261 2.34845 10.3046 2.47767 11.4969 2.97153C12.6891 3.46539 13.7082 4.30172 14.4252 5.37475C15.1422 6.44778 15.5248 7.70932 15.5248 8.99984C15.5229 10.7298 14.8348 12.3883 13.6115 13.6115C12.3883 14.8348 10.7298 15.5229 8.99985 15.5248Z"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
      <path
        d="M12.5326 12.6826C12.611 12.6052 12.6733 12.5129 12.7159 12.4112C12.7584 12.3095 12.7803 12.2004 12.7803 12.0901C12.7803 11.9799 12.7584 11.8707 12.7159 11.769C12.6733 11.6673 12.611 11.5751 12.5326 11.4976L9.53258 8.53512C9.36762 8.40853 9.16157 8.34762 8.9543 8.36418C8.74703 8.38073 8.55326 8.47357 8.41049 8.62475C8.26771 8.77592 8.18608 8.97467 8.18139 9.18255C8.1767 9.39043 8.24927 9.59266 8.38508 9.75012L11.3851 12.7126C11.5437 12.8558 11.7512 12.9326 11.9648 12.927C12.1784 12.9214 12.3817 12.8339 12.5326 12.6826V12.6826ZM8.11508 4.90512V9.09012C8.10404 9.2066 8.11745 9.32409 8.15445 9.43508C8.19145 9.54607 8.25123 9.64811 8.32996 9.73465C8.40869 9.8212 8.50463 9.89034 8.61163 9.93765C8.71863 9.98497 8.83433 10.0094 8.95133 10.0094C9.06832 10.0094 9.18403 9.98497 9.29103 9.93765C9.39803 9.89034 9.49397 9.8212 9.5727 9.73465C9.65142 9.64811 9.7112 9.54607 9.74821 9.43508C9.78521 9.32409 9.79862 9.2066 9.78758 9.09012V4.90512C9.79862 4.78865 9.78521 4.67116 9.74821 4.56017C9.7112 4.44918 9.65142 4.34714 9.5727 4.2606C9.49397 4.17405 9.39803 4.10491 9.29103 4.05759C9.18403 4.01028 9.06832 3.98584 8.95133 3.98584C8.83433 3.98584 8.71863 4.01028 8.61163 4.05759C8.50463 4.10491 8.40869 4.17405 8.32996 4.2606C8.25123 4.34714 8.19145 4.44918 8.15445 4.56017C8.11745 4.67116 8.10404 4.78865 8.11508 4.90512V4.90512Z"
        fill={fill || 'var(--SECONDARY_LIGHT)'}
      />
    </g>
    <defs>
      <clipPath id="clip0_2513_7837">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

Timer.propTypes = {
  fill: PropTypes.string,
  onClick: PropTypes.func,
};

export default Timer;
